import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

interface CustomIcons {
  extraSmall?: React.ReactNode;
  small: React.ReactNode;
  medium: React.ReactNode;
  large: React.ReactNode;
}

const ChevronDownIcons: CustomIcons = {
  extraSmall: (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3 4.5L6 7.5L9 4.5"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  small: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4 6.66669L8 10.6667L12 6.66669"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  medium: (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6 10L12 16L18 10"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  large: (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8 13.3333L16 21.3333L24 13.3333"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
};

function ChevronDownIcon(props: SvgIconProps) {
  const { fontSize } = props;

  const fSize = fontSize !== "inherit" ? fontSize : "medium";
  const content = ChevronDownIcons[fSize || "medium"];

  return <SvgIcon {...props}>{content}</SvgIcon>;
}
export default ChevronDownIcon;
